import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from "@angular/core";
import { DateHelper } from "../../../../../utilities/contracts/date-helper";

@Component({
  selector: "app-allocation-summary",
  templateUrl: "./allocation-summary.component.html",
  styleUrls: ["./allocation-summary.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllocationSummaryComponent {
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() projectLastLoadDate: Date;
  @Input() projectLastLoadUser: string;

  readonly totalTooltip = "All chases loaded to this project.";
  readonly remainingTooltip = "Chases that have not yet reached a completed status.";
  readonly completedTooltip = "Chases that have reached a completed status.";

  get hasTimeline(): boolean {
    return DateHelper.isAvailable(this.startDate) && DateHelper.isAvailable(this.endDate);
  }

  get hasLastLoad(): boolean {
    return DateHelper.isAvailable(this.projectLastLoadDate);
  }
}
